<aside class="sidebar h-100">
  <div class="sidebar-content">
    <nav class="main-menu" (mouseenter)="removeClass()" (mouseleave)="closeSidebarIfAllowed()">
      <ul class="nav metismenu">
        <li class="d-block d-lg-none" (click)="closeSidebarIfAllowed()">
          <div class="px-1 d-flex justify-content-end align-items-center">
            <img src="assets/icons/close.svg" class="h-40" />
          </div>
        </li>

        <li [ngClass]="{ 'active': isMenuOpen('reports') }">
          <a (click)="toggleMenu('reports')" class="d-flex align-items-center">
            <div class="vertical-separator"></div>
            <img class="sidebar-img-active" src="assets/icons/clipboard-active.svg" />
            <img class="sidebar-img-inactive" src="assets/icons/clipboard-inactive.svg" />
            <span>Reports</span>
            <img class="dropdown-icon text-end ml-auto" src="assets/icons/chevron-down.svg"
              [class.open]="isMenuOpen('reports')" />
          </a>
          <div class="dropdown-menu-right dropdown-menu-account m-0" [class.open]="isMenuOpen('reports')"
            [class.close]="!isMenuOpen('reports')">
            <a (click)="showHideSidebar()" routerLink="/report/quick" class="dropdown-item">Quick Report</a>
            <a *ngIf="shouldShowDashboard()" 
               (click)="showHideSidebar()" 
               routerLink="/report/app-focused-dashboard" 
               class="dropdown-item">App-Focussed Dashboard</a>
            <a (click)="showHideSidebar()" routerLink="/report/performance" class="dropdown-item">Performance</a>
            <a (click)="showHideSidebar()" routerLink="/report/transactions" class="dropdown-item">Transaction</a>
            <a (click)="showHideSidebar()" routerLink="/report/click" class="dropdown-item">Clicks</a>
            <ng-container *ngIf="shouldShowItemFor(AccountType.ADMIN)">
              <a class="dropdown-item" routerLink="/report/failed-events" (click)="showHideSidebar()">Failed Events</a>
            </ng-container>
          </div>
        </li>

        <li *ngIf="shouldShowItemFor(AccountType.ADVERTISER)" routerLink="/ad-space/adspace-list" (click)="showHideSidebar()">
          <a class="d-flex align-items-center">
            <div class="vertical-separator"></div>
            <img class="sidebar-img-active" src="assets/icons/accounts-active.svg" />
            <img class="sidebar-img-inactive" src="assets/icons/accounts-active.svg" />
            <span>Publisher Management</span>
          </a>
        </li>

        <li *ngIf="shouldShowItemFor(AccountType.ADMIN)" [class.active]="isMenuOpen('accountAdministration')">
          <a (click)="toggleMenu('accountAdministration')" class="d-flex align-items-center">
            <div class="vertical-separator"></div>
            <img class="sidebar-img-active" src="assets/icons/user-cog-active.svg" />
            <img class="sidebar-img-inactive" src="assets/icons/user-cog-inactive.svg" />
            <span>Account Administration</span>
            <ng-container>
              <img class="dropdown-icon text-end ml-auto" src="assets/icons/chevron-down.svg"
                [class.open]="isMenuOpen('accountAdministration')" />
            </ng-container>
          </a>
          <div class="dropdown-menu-right dropdown-menu-account m-0" [class.open]="isMenuOpen('accountAdministration')"
            [class.close]="!isMenuOpen('accountAdministration')">
            <a (click)="showHideSidebar()" routerLink="/account-administration/publisher-list" class="dropdown-item">
              Publisher
            </a>
            <a (click)="showHideSidebar()" routerLink="/account-administration/advertiser-list" class="dropdown-item">
              Advertiser
            </a>
          </div>
        </li>

        <li *ngIf="shouldShowItemFor(AccountType.ADVERTISER)" routerLink="/offer/list" (click)="showHideSidebar()">
          <a class="d-flex align-items-center">
            <div class="vertical-separator"></div>
            <img class="sidebar-img-active" src="assets/icons/basket-active.svg" />
            <img class="sidebar-img-inactive" src="assets/icons/basket-inactive.svg" />
            <span>My Campaigns</span>
          </a>
        </li>

        <li *ngIf="shouldShowItemFor(AccountType.ADMIN)" [class.active]="isMenuOpen('adManagement')">
          <a (click)="toggleMenu('adManagement')" class="d-flex align-items-center">
            <div class="vertical-separator"></div>
            <img class="sidebar-img-active" src="assets/icons/basket-active.svg" />
            <img class="sidebar-img-inactive" src="assets/icons/basket-inactive.svg" />
            <span>Ad Management</span>
            <ng-container>
              <img class="dropdown-icon text-end ml-auto" src="assets/icons/chevron-down.svg"
                [class.open]="isMenuOpen('adManagement')" />
            </ng-container>
          </a>
          <div class="dropdown-menu-right dropdown-menu-account m-0" [class.open]="isMenuOpen('adManagement')"
            [class.close]="!isMenuOpen('adManagement')">
            <a (click)="showHideSidebar()" routerLink="/ad-space/adspace-list" class="dropdown-item">AdSpaces</a>
            <a (click)="showHideSidebar()" routerLink="/offer/list" class="dropdown-item">Campaigns</a>
          </div>
        </li>

        <li *ngIf="shouldShowItemFor(AccountType.PUBLISHER)" routerLink="/offer/list" (click)="showHideSidebar()">
          <a class="d-flex align-items-center">
            <div class="vertical-separator"></div>
            <img class="sidebar-img-active" src="assets/icons/basket-active.svg" />
            <img class="sidebar-img-inactive" src="assets/icons/basket-inactive.svg" />
            <span>Campaign Overview</span>
          </a>
        </li>

        <li *ngIf="shouldShowItemFor(AccountType.PUBLISHER)" routerLink="/postbacks" (click)="showHideSidebar()">
          <a class="d-flex align-items-center">
            <div class="vertical-separator"></div>
            <img class="sidebar-img-active" src="assets/icons/postback-active.svg" />
            <img class="sidebar-img-inactive" src="assets/icons/postback-active.svg" />
            <span>Postbacks</span>
          </a>
        </li>

        <li (click)="showHideSidebar()">
          <a class="d-flex align-items-center text-decoration-none" routerLink="/finance/list">
            <div class="vertical-separator"></div>
            <img class="sidebar-img-active" src="assets/icons/coin-active.svg" />
            <img class="sidebar-img-inactive" src="assets/icons/coin-inactive.svg" />
            <span>Finance</span>
          </a>
        </li>
      </ul>
    </nav>
  </div>
</aside>
<div class="main-content position-relative">
  <div class="collapse-menu" (click)="toggleCollapsibleMenu()">
    <span class="mr-2">Collapse Menu</span>
    <img class="ml-0" src="assets/icons/collapse.svg" />
  </div>
  <!-- Main content goes here -->
</div>
